// ReglasPopup.jsx

import React from 'react';
import Modal from 'react-modal';
import './reglspopup.css';
import { useTranslation } from 'react-i18next';

Modal.setAppElement('#root'); // Necesario para cumplir con las pautas de accesibilidad



const ReglasPopup = ({ isOpen, onClose }) => {
  const handleButtonClick = () => {
    // Lógica para manejar el clic del botón debajo del modal
    alert('Botón clickeado');
  };

  const [t, i18n] = useTranslation("detail_blog");

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className='content_r' >
      <div>
        <h2 className='title'>{(t('reglas.rule1'))}</h2>
        <p className='text'>
        {(t('reglas.rule2'))}
        </p>
        <p className='text'>{(t('reglas.rule3'))}<br/><br/>
        <span className='subtitle'>{(t('reglas.rule4'))}</span><br/><br/>
        <span className='bold'>•</span>{(t('reglas.rule5'))}<br/>
        <span className='bold'>•</span>{(t('reglas.rule6'))}<br/>
        <span className='bold'>•</span>{(t('reglas.rule7'))}<br/>
        <span className='bold'>•</span>{(t('reglas.rule8'))}<br/><br/>
          <span className='subtitle'>{(t('reglas.rule9'))}</span><br/><br/>
          <span className='bold'>•</span>{(t('reglas.rule10'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule11'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule12'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule13'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule14'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule15'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule16'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule17'))}<br/>
          <span className='bold'>•</span>{(t('reglas.rule18'))}<br/>
          {(t('reglas.rule19'))}<br/>
          {(t('reglas.rule20'))}<br/>
          {(t('reglas.rule21'))}&nbsp;
 
          <a href="comentarios.ricardosalinas@gruposalinas.com.mx" target="_blank" rel="noopener noreferrer">
           comentarios.ricardosalinas@gruposalinas.com.mx
          </a>
        </p>
        <div onClick={onClose} className='boton-container_r'>
        
        <p className='boton_V'>{(t('reglas.rule22'))}</p>
        </div>
       
      </div>
      {/* Agregado un botón debajo del modal */}
      
    </Modal>
  );
};

export default ReglasPopup;
